

export const CHAT_BASE_URL =
  (process.env.REACT_APP_CHAT_BASE_URL ?? "http://127.0.0.1:8000").replace(/\/$/, "");

// The Pre-Sales-Data-Uploader service — a separate backend process from the chat
// backend above (CHAT_BASE_URL) and the general REACT_APP_BASE_URL (also the chat
// backend). Uploads, reindexing, and video-upload-status polling only exist on this
// service, so those specific calls must be routed here, not through Post/Get.
export const UPLOAD_BASE_URL =
  (process.env.REACT_APP_UPLOAD_BASE_URL ?? "http://127.0.0.1:8001/api").replace(/\/$/, "");

export const networkUrls = {
  googleLogin: "/auth/google-login",
  searchQuery: "/search",
  chatQuery: "/api/chat",
  failedQuery: "/log-failed-query",
  projectDocuments: "/documents",
  singleProjectDocumnet: "/documents",
  singleIndustryTrack: "/get-single-industry-track",
  uploadCaseStudy: "/upload-case-study",
  uploadIndustryTrack:"/upload-industry-track",
  updateDocument:"/update-ppt-name",
  deleteDocument:"/delete-document",
  genaratePPT:"/generate-ppt",
  genarateDOCX:"/generate-docx",
  updateMetadata:"/update-project-document-metadata",
  updateTranscriptMeatadata:"/update-transcript-metadata",
  fetchQueries:"/frequent-queries",
  fetchIndustryTrack:"/get-industry-track",
  raisedQueryTicekt:"/raise-ticket",
  downloadCaseStudy:"/download",
  grantDriveAccess:"/grant-drive-access",
  uploadCertification:"/upload-certifications",
  certifications:"/certifications",
  addCertification:"/add-certification",
  updateCertification:"/update-certification",
  deleteCertification:"/delete-certification",
  addIndustryTrack:"/add-industry-track",
  updateIndustryTrack:"/update-industry-track",
  deleteIndustryTrack:"/delete-industry-track",
  uploadVideo:"/videos/upload",
  videoUploadStatus:"/videos/upload/status",
  getAllVideos:"/videos",
  getSingleVideo:"/video",
  deleteVideo:"/delete-video",
  updateTranscriptName:"/update-transcript-name",
  updateVideoName:"/update-video-name",
  uploadAllowedUsers:"/upload-allowed-users",
  users:"/allowed-users",
  addUser:"/add-allowed-users",
  updateUser:"/update-allowed-user",
  deleteUser:"/delete-allowed-users",
  chatSessions:"/api/chat-sessions",
  applicationReports:"/application-report",
  userActivityReport:"/reports/user-activity",
  usernamesList:"/reports/usernames",
  industryTrackContentIndustries:"/industry-track-content/industries",
  industryTrackContentCategories:"/industry-track-content/categories",
  industryTrackContentUpload:"/industry-track-content/upload",
  industryTrackContentDocuments:"/industry-track-content/documents",
  industryTrackContentDeleteDocument:"/industry-track-content/documents",
  documentSummary:"/api/document-summary",
  reindex:"/reindex",
  reindexStatus:"/reindex/status",
  speechToText:"/api/speech-to-text",
};
